import { useAutoLoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useAutoLoanPaymentMethodDetailEntity';
import { useCheckoutSession } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSession';
import { useCheckoutSessionCart } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSessionCart';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useUser } from '@/hooks/useUser';

export const useCheckoutSessionAutoCart = () => {
  const { checkoutSessionEntity, checkoutSession, cartSummaryData, downPayment, discount } = useCheckoutSessionCart();
  const autoLoanEntity = useAutoLoanPaymentMethodDetailEntity();
  const { isUserAdmin, isUserAgent, isUserMerchant, isUserChannel } = useUser();
  const { getTextIdTranslation } = useTranslation();
  const { refreshCheckoutSessionAndPaymentMethodEntities } = useCheckoutSession();

  const isUserAllowedToEditVehicleData = isUserAdmin || isUserAgent || isUserMerchant || isUserChannel;

  const capability = autoLoanEntity?.modificationCapability;
  const isCapabilityReady = !!capability;

  const canShowEditVehicleDataButton =
    !!autoLoanEntity?.isAuto() && isCapabilityReady && capability.lenderAllowsModification;

  const shouldShowEditVehicleDataLenderMessage =
    !!autoLoanEntity?.isAuto() && isCapabilityReady && capability.modifiable && !capability.lenderAllowsModification;

  const isEditVehicleDataButtonDisabled = !autoLoanEntity?.isVehicleDataEditable();
  const selectedLender = autoLoanEntity?.selectedProvider ? getTextIdTranslation(autoLoanEntity.selectedProvider) : '';

  const areFinancingConditionsEditable = () => autoLoanEntity?.isVehicleAmountEditable();

  return {
    checkoutSessionEntity,
    checkoutSession,
    cartSummaryData,
    downPayment,
    discount,
    isUserAllowedToEditVehicleData,
    canShowEditVehicleDataButton,
    shouldShowEditVehicleDataLenderMessage,
    isEditVehicleDataButtonDisabled,
    selectedLender,
    refreshCheckoutSessionAndPaymentMethodEntities,
    areFinancingConditionsEditable: areFinancingConditionsEditable(),
  };
};
